import { useEffect, useState } from "react";
import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import CertificationStatus from "../../Models/common/CertificationStatus";
import { isCBCommercialHorizonUser, isCBUser } from "../../Authentication/Auth";

const useGetCertificationStatuses = () => {
  const [certificationStatuses, setCertificationStatuses] = useState<
    CertificationStatus[]
  >([]);
  useEffect(() => {
    axiosApi
      .get<CertificationStatus[]>(
        isCBCommercialHorizonUser() ? `${BackendServices.AUDIT_SERVICE.VERIFY}/CertificationStatus` :`${BackendServices.AUDIT_SERVICE.AUDIT}/CertificationStatus`
      )
      .then(({ data }) => {
        setCertificationStatuses(data);
      })
      .catch(() => setCertificationStatuses([]));
  }, []);
  return { certificationStatuses };
};

export default useGetCertificationStatuses;
